import React from 'react'

import styled from 'styled-components'

import Share from 'src/Assets/Svg/common/share.svg?react'
import {
  SquareButton,
  SquareButtonProps,
} from 'src/Components/Buttons/SquareButton'

const StyledButton = styled(SquareButton)`
  padding: 0 12px;
  flex-grow: 0;
`

const ChildrenWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 8px;
`

export type ShareButtonProps = SquareButtonProps & {
  withText?: boolean
}

export const ShareButton: React.FC<ShareButtonProps> = ({
  loading,
  onClick,
  disabled,
  withText,
  ...rest
}) => (
  <StyledButton
    loading={loading}
    disabled={disabled}
    onClick={onClick}
    {...rest}
  >
    <ChildrenWrapper>
      {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
      <>
        <Share />
      </>
      {withText && <span>Share</span>}
    </ChildrenWrapper>
  </StyledButton>
)
